import loadable from '@loadable/component';
import React from 'react';
import { connect } from 'react-redux';
import { ConnectedProps, DiscoverState } from '../../../../types/index';
import {
    clickOnOnlineCollection,
    clickOnTransitionOnlineCollection,
} from '../../redux/content';

const CollectionsBucket = loadable(
    () => import('../../../../components/FeaturedCollections'),
    {
        resolveComponent: (components: {
            CollectionsBucket: React.ReactElement;
        }) => components.CollectionsBucket,
    },
);

const CollectionsBucketContainer = (props: CollectionsBucketContainerProps) => {
    const {
        isFeLoading,
        trackGAEvent,
        trackGAEventOnPageUnload,
        tld,
        placeId,
    } = props;

    let bucketContent = null;

    if (!isFeLoading) {
        bucketContent = (
            <CollectionsBucket
                tld={tld}
                currentPlace={placeId || 'online'}
                trackGAEvent={trackGAEvent}
                trackGAEventOnPageUnload={trackGAEventOnPageUnload}
            />
        );
    }

    return bucketContent;
};

const _mapStateToProps = ({ app, location }: DiscoverState) => ({
    isFeLoading: app.loadingState && app.loadingState.isFeLoading,
    isBotRequest: app.isBotRequest,
    placeId: location.placeId,
    tld: app.tld,
});

const _mapDispatchToProps = {
    trackGAEventOnPageUnload: clickOnOnlineCollection,
    trackGAEvent: clickOnTransitionOnlineCollection,
};

type CollectionsBucketContainerProps = ConnectedProps<
    typeof _mapStateToProps,
    typeof _mapDispatchToProps
>;
export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(CollectionsBucketContainer);
